// TipoCierre.js - Opciones de Estado de Cierre para casos

export const tiposCierre = [
  { value: -1, label: "TODOS" },
  { value: 0, label: "SIN CERRAR" },
  { value: 1, label: "CERRADO MANTIENE IGUAL DEUDA" },
  { value: 2, label: "CERRADO CANCELACION TOTAL" },
  { value: 3, label: "CERRADO SE INCREMENTO DEUDA" },
  { value: 4, label: "CERRADO CANCELACION PARCIAL" },
  { value: 5, label: "CERRADOS" }
];

// Estado de cierre de los casos cualitativos: el resultado se calcula al importar el archivo de cierre.
export const tiposCierreCualitativo = [
  { value: -1, label: "TODOS" },
  { value: 0, label: "SIN CERRAR" },
  { value: 1, label: "CERRADO CUMPLIDO" },
  { value: 2, label: "CERRADO CUMPLIDO PARCIAL" },
  { value: 3, label: "CERRADO NO CUMPLIDO" },
  { value: 5, label: "CERRADOS" }
];

export const getTipoCierreDescripcion = (tipoCierre) => {
  // Si es null o undefined, se considera ACTIVO por defecto
  if (tipoCierre === null || tipoCierre === undefined || tipoCierre === 0) return "ACTIVO";
  
  switch (tipoCierre) {
    case 0:
      return "SIN CERRAR";
    case 1:
      return "CERRADO MANTIENE IGUAL DEUDA";
    case 2:
      return "CERRADO CANCELACION TOTAL";
    case 3:
      return "CERRADO SE INCREMENTO DEUDA";
    case 4:
      return "CERRADO CANCELACION PARCIAL";
    case 5:
      return "CERRADOS";
    default:
      return "SIN CERRAR";
  }
};
